import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px; /* Use px for default font scaling */
  }

  .grecaptcha-badge {
    transform: scale(0.5);
    transform-origin: left;
    visibility: hidden;
  }
`;

export default GlobalStyle;
